import React from 'react'
import { ButtonRedirectProps } from '../../types/components/buttonRedirect'
import { ButtonRedirectStyle } from './style'

export const ButtonRedirect: ButtonRedirectProps = ({ link, nameButton }) => {
  return <ButtonRedirectStyle href={link}>{nameButton}</ButtonRedirectStyle>
}
